// @flow
import {connect} from 'react-redux';
import {compose, withProps} from 'react-recompose';

import {toggleSelectedAgreement} from '../../../modules/Agreements/actions';
import {
  agreementSpecificationsSelector,
  agreementsStateSelector,
} from '../../../modules/Agreements/selectors';
import {isLoadingSelector} from '../../../modules/LoadingStatus/reducer';
import {balanceSelector} from '../../../modules/Customer/selectors';
import {promotionSelector} from '../../../modules/SignUp/Bonus';
import {getVisibleNumbers} from '../../../scenes/TopUp/lib/';
import formatAmount from '../../../lib/formatAmount';
import I18n from '../../../lib/i18n';
import config from '../../../config';

import type {AgreementSpecification} from 'digicel-kaizen-library';
import type {PromotionType} from '../../../modules/SignUp/Bonus';

import ConfirmPlan from './ConfirmPlan';
import { fetchFreeTrialActivationBonus, freeTrialActivationBonusStateSelector } from '../../../modules/Bonuses';

type StateProps = {
  agreements: ?(AgreementSpecification[]),
  isConfirmPlanLoading: boolean,
  promotion: ?PromotionType,
  toggleAgreements: boolean,
  walletBalance: ?number,
};

type DispatchProps = {
  toggleSelectedAgreement: Function,
};

type FlaggedProps = {
  displayPricesShownAreExclusiveOfTaxMessage: boolean,
  displayConditionsModal: boolean,
  canEnterReferralOrPromoCode: boolean,
  canEditOffer: boolean,
  confirmationModalBody: Function,
};

const mapStateToProps = (state: any): StateProps => ({
  agreements: agreementSpecificationsSelector(state),
  isConfirmPlanLoading: isLoadingSelector(state, 'confirmPlan'),
  promotion: promotionSelector(state),
  toggleAgreements: agreementsStateSelector(state),
  walletBalance: balanceSelector(state),
  freeTrialActivationBonus: freeTrialActivationBonusStateSelector(state),
});

const mapDispatchToProps: DispatchProps = {
  toggleSelectedAgreement,
  fetchFreeTrial: () => fetchFreeTrialActivationBonus(),
};

const confirmationModalBody = (
  price: ?number,
  paymentMean,
  walletBalance: number | null,
  currentVoucherDetails?: Object,
) => {
  if (price === undefined || price === null) {
    return;
  }

  if (price > 0) {
    if (walletBalance !== null && walletBalance - price >= 0) {
      const textContent = I18n.t(
        currentVoucherDetails
          ? 'SignUp.ConfirmPlan.modal.body.walletVoucher'
          : 'SignUp.ConfirmPlan.modal.body.wallet',
        {
          price: formatAmount(price),
        },
      );

      return textContent;
    }

    if (paymentMean) {
      const textContent = I18n.t(
        currentVoucherDetails
          ? 'SignUp.ConfirmPlan.modal.body.creditCardVoucher'
          : 'SignUp.ConfirmPlan.modal.body.creditCard',
        {
          cardNumber: getVisibleNumbers(paymentMean.functionalId),
          price: formatAmount(price),
        },
      );
      return textContent;
    }
  } else {
    return I18n.t('SignUp.ConfirmPlan.modal.body.nothingToPay');
  }
};

const withFlaggedProps = (): FlaggedProps => ({
  displayPricesShownAreExclusiveOfTaxMessage:
    config.displayPricesShownAreExclusiveOfTaxMessage,
  displayConditionsModal: config.displayConditionsModalOnConfirmPlan,
  canEnterReferralOrPromoCode: config.canEnterReferralOrPromoCode,
  canEditOffer: config.canEditOfferOnConfirmPlan,
  confirmationModalBody,
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(withFlaggedProps),
)(ConfirmPlan);
